import {Component, Input} from '@angular/core';
import {roles, rolesLabelMap} from "../../../../constants/common.constants";
import { PhoneNumberFormatPipe } from "../../../../pipes/phone-number-format.pipe";

@Component({
  selector: 'app-clinic-details',
  templateUrl: './clinic-details.component.html',
  styleUrls: ['./clinic-details.component.css']
})
export class ClinicDetailsComponent {
  @Input() userDetails;
  @Input() loading;
  phoneNumber: any;

  protected readonly rolesLabelMap = rolesLabelMap;
  protected readonly roles = roles;

  constructor(private phoneNumberFormatPipe: PhoneNumberFormatPipe) {
  }

  ngOnInit() {
    this.phoneNumber = this.phoneNumberFormatPipe.transform(this.userDetails?.clientPhoneNumber);
  }

}
